import { render, staticRenderFns } from "./goodsModule.vue?vue&type=template&id=712c11c0&scoped=true"
import script from "./goodsModule.vue?vue&type=script&lang=js"
export * from "./goodsModule.vue?vue&type=script&lang=js"
import style0 from "./goodsModule.vue?vue&type=style&index=0&id=712c11c0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "712c11c0",
  null
  
)

export default component.exports